// extracted by mini-css-extract-plugin
export default {"ricosDisabled":"kxwXuV","checkbox":"YFj6L3"};